// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2024 Étienne FOLIO
 * Tous droits réservés.
 *
 * Ce fichier fait partie d'un logiciel propriétaire.
 * Toute reproduction, modification ou distribution, totale ou partielle,
 * de ce fichier est interdite sans l'autorisation écrite préalable
 * de l'auteur.
 */

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

html, body, #root {
  margin: 0;
  padding: 0;
  height: 100%;
}

.app-shell {
  height: 100vh;
  overflow: hidden;
}

.app-main {
  min-height: 0;
  overflow: hidden;
}

.app-main-row {
  height: 100%;
  min-height: 0;
  flex-wrap: nowrap;
}

.app-sidebar {
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.app-content {
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  overflow-x: auto;
}

.config-settings-layout {
  min-height: 0;
}

.config-settings-sidebar {
  position: sticky;
  top: 0;
  max-height: calc(100vh - 11rem);
  overflow-y: auto;
  overflow-x: hidden;
}

.config-settings-sticky-actions {
  position: sticky;
  bottom: -1px;
  z-index: 60;
  isolation: isolate;
  overflow: visible;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.75rem 0 0.5rem;
  margin-top: 1rem;
  margin-bottom: -1px;
  background-color: var(--bs-body-bg, #ffffff);
  border-top: 1px solid var(--bs-border-color, #dee2e6);
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.12);
}

.config-settings-sticky-actions::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -24px;
  height: 24px;
  pointer-events: none;
  background-color: var(--bs-body-bg, #ffffff);
}

.config-history-collapsible {
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 0.375rem;
  padding: 0.25rem 0.75rem 0.5rem;
  background-color: var(--bs-body-bg, #ffffff);
}

.config-history-collapsible > summary {
  cursor: pointer;
  font-weight: 600;
  list-style: none;
  padding: 0.125rem 0;
}

.config-history-collapsible > summary::-webkit-details-marker {
  display: none;
}

.config-history-collapsible > summary::after {
  content: "▸";
  float: right;
  transition: transform 0.15s ease;
}

.config-history-collapsible[open] > summary::after {
  transform: rotate(90deg);
}

.release-notes-content .release-notes-collapsible {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.release-notes-content .release-notes-version {
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 0.375rem;
  padding: 0.25rem 0.75rem 0.5rem;
  background-color: var(--bs-body-bg, #ffffff);
}

.release-notes-content .release-notes-version > summary {
  cursor: pointer;
  font-weight: 600;
  list-style: none;
  padding: 0.125rem 0;
}

.release-notes-content .release-notes-version > summary::-webkit-details-marker {
  display: none;
}

.release-notes-content .release-notes-version > summary::after {
  content: "▸";
  float: right;
  transition: transform 0.15s ease;
}

.release-notes-content .release-notes-version[open] > summary::after {
  transform: rotate(90deg);
}

.release-notes-content .release-notes-version[open] > summary {
  margin-bottom: 0.25rem;
}

.release-notes-content .release-notes-version-body > *:last-child {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAEF;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;EAC5C,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,iDAAiD;EACjD,uBAAuB;EACvB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iDAAiD;EACjD,uBAAuB;EACvB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/*\n * Copyright (c) 2024 Étienne FOLIO\n * Tous droits réservés.\n *\n * Ce fichier fait partie d'un logiciel propriétaire.\n * Toute reproduction, modification ou distribution, totale ou partielle,\n * de ce fichier est interdite sans l'autorisation écrite préalable\n * de l'auteur.\n */\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\nhtml, body, #root {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\n.app-shell {\n  height: 100vh;\n  overflow: hidden;\n}\n\n.app-main {\n  min-height: 0;\n  overflow: hidden;\n}\n\n.app-main-row {\n  height: 100%;\n  min-height: 0;\n  flex-wrap: nowrap;\n}\n\n.app-sidebar {\n  height: 100%;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.app-content {\n  height: 100%;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: auto;\n}\n\n.config-settings-layout {\n  min-height: 0;\n}\n\n.config-settings-sidebar {\n  position: sticky;\n  top: 0;\n  max-height: calc(100vh - 11rem);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.config-settings-sticky-actions {\n  position: sticky;\n  bottom: -1px;\n  z-index: 60;\n  isolation: isolate;\n  overflow: visible;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  padding: 0.75rem 0 0.5rem;\n  margin-top: 1rem;\n  margin-bottom: -1px;\n  background-color: var(--bs-body-bg, #ffffff);\n  border-top: 1px solid var(--bs-border-color, #dee2e6);\n  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.12);\n}\n\n.config-settings-sticky-actions::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -24px;\n  height: 24px;\n  pointer-events: none;\n  background-color: var(--bs-body-bg, #ffffff);\n}\n\n.config-history-collapsible {\n  border: 1px solid var(--bs-border-color, #dee2e6);\n  border-radius: 0.375rem;\n  padding: 0.25rem 0.75rem 0.5rem;\n  background-color: var(--bs-body-bg, #ffffff);\n}\n\n.config-history-collapsible > summary {\n  cursor: pointer;\n  font-weight: 600;\n  list-style: none;\n  padding: 0.125rem 0;\n}\n\n.config-history-collapsible > summary::-webkit-details-marker {\n  display: none;\n}\n\n.config-history-collapsible > summary::after {\n  content: \"▸\";\n  float: right;\n  transition: transform 0.15s ease;\n}\n\n.config-history-collapsible[open] > summary::after {\n  transform: rotate(90deg);\n}\n\n.release-notes-content .release-notes-collapsible {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.release-notes-content .release-notes-version {\n  border: 1px solid var(--bs-border-color, #dee2e6);\n  border-radius: 0.375rem;\n  padding: 0.25rem 0.75rem 0.5rem;\n  background-color: var(--bs-body-bg, #ffffff);\n}\n\n.release-notes-content .release-notes-version > summary {\n  cursor: pointer;\n  font-weight: 600;\n  list-style: none;\n  padding: 0.125rem 0;\n}\n\n.release-notes-content .release-notes-version > summary::-webkit-details-marker {\n  display: none;\n}\n\n.release-notes-content .release-notes-version > summary::after {\n  content: \"▸\";\n  float: right;\n  transition: transform 0.15s ease;\n}\n\n.release-notes-content .release-notes-version[open] > summary::after {\n  transform: rotate(90deg);\n}\n\n.release-notes-content .release-notes-version[open] > summary {\n  margin-bottom: 0.25rem;\n}\n\n.release-notes-content .release-notes-version-body > *:last-child {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
